import { Link } from 'react-router-dom';
import PageHero from '../components/aravi/PageHero';

export default function NotFound() {
  return (
    <div className="bg-[#F5F1E8] min-h-screen">
      <PageHero
        eyebrow="404 — Off the Map"
        title={<>You&apos;ve<br/>wandered off-trail.</>}
        intro="The page you were looking for has moved or never existed. The forest, however, is still here."
      />
      <section className="bg-[#F5F1E8] py-20 lg:py-24">
        <div className="px-6 md:px-10 lg:px-16 max-w-[1500px] mx-auto">
          <Link
            to="/"
            className="inline-flex items-center gap-3 bg-[#18342A] text-[#F5F1E8] px-7 py-4 text-[11px] tracking-[0.28em] uppercase hover:bg-[#C9A458] hover:text-[#18342A] transition-colors"
          >
            Return Home
          </Link>
        </div>
      </section>
    </div>
  );
}
